<template>
  <ul class="viewer-thumbnails">
    <li v-for="canvas in canvases"
        class="viewer-thumbnails__item">
      <a @click="updateSelection(canvas)">
        <clazy-load :src="getThumbnailImage(canvas)">
          <img :src="getThumbnailImage(canvas)" slot="image" />
          <div class="preloader">
            Loading...
          </div>
        </clazy-load>
        <p>{{ canvas.label }}</p>
      </a>
    </li>
  </ul>
</template>

<script>
export default {
  name: 'Thumbnails',
  props: ['canvases'],
  methods: {
    getThumbnailImage (canvas) {
      let iiifEndpoint = canvas.images[0].resource.service['@id']
      return `${iiifEndpoint}/full/150,/0/default.jpg`
    },
    updateSelection (canvas) {
      this.$emit('canvas-select', canvas)
    }
  }
}
</script>

<style lang="scss" scoped>
.viewer-thumbnails {
  list-style: none;
  white-space: nowrap;

  &__item {
    box-sizing: border-box;
    background-size: contain;
    background-repeat: no-repeat;
    color: #fff;
    display: inline-block;
    height: 180px;
    width: 180px;
    margin: 10px;

    img {
      background-color: #ccc;
      height: 150px;
      display: block;
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/components/viewer/Thumbnails.vue?713b79fc